var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBreadcrumbChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1719 12.0002L8.92892 7.75723C8.53846 7.36677 8.53846 6.7337 8.92892 6.34323C9.31939 5.95277 9.95246 5.95277 10.3429 6.34323L15.2928 11.2931C15.6833 11.6836 15.6833 12.3168 15.2928 12.7073L10.3429 17.6572C9.95246 18.0477 9.31939 18.0477 8.92892 17.6572C8.53846 17.2668 8.53846 16.6337 8.92892 16.2432L13.1719 12.0002Z",
    fill: "#545A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBreadcrumbChevronRight);
export default __webpack_public_path__ + "static/media/icon-breadcrumb-chevron-right.d86ad03561fc89ebe2151dd0101065cb.svg";
export { ForwardRef as ReactComponent };